var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"admin-management-modal",attrs:{"name":"admin-management-modal","width":'400px',"height":'auto'},on:{"before-close":_vm.handlerBeforeClose,"before-open":_vm.handlerBeforeOpen,"opened":_vm.handlerOpened}},[_c('admin-write-component',{attrs:{"adminType":_vm.adminType,"adminKey":_vm.adminKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }